const custodialData = {
    custodial_first_name: '',
    custodial_last_name: '',
    custodial_middle_name: '',
    custodial_ssn: '',
    custodial_birth: '',
    custodial_type: 'UTMA'
}

const SET_CUSTODIAL_INFO = 'SET_CUSTODIAL_INFO';
const SET_CUSTODIAL_TYPE = 'SET_CUSTODIAL_TYPE';

export const setCustodialData = (custodialData) => ({
    type: SET_CUSTODIAL_INFO,
    payload: custodialData,
});

export const setCustodialType = (custodial_type) => ({
    type: SET_CUSTODIAL_TYPE,
    payload: custodial_type,
});

const custodial_store = (state = custodialData, action) => {
    switch (action.type) {
        case SET_CUSTODIAL_TYPE:
            return {
                ...state,
                custodial_type: action.payload,
            };
        case SET_CUSTODIAL_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default custodial_store;
